// extracted by mini-css-extract-plugin
export var container = "DeilveryUpdateTable_container__R-ssj";
export var drawerToggleButton = "DeilveryUpdateTable_drawerToggleButton__PopH8";